// extracted by mini-css-extract-plugin
export var parcelRow = "_vi-0";